// extracted by mini-css-extract-plugin
module.exports = {"navigation":"mobile_navigation__zmLV4","screen":"mobile_screen__o3OFB"};